import { Box, Typography } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";

function LoginDialog() {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <BlockIcon sx={{ color: "red" }} />
        <Typography variant="h6" ml={1}>
          Your account is <span style={{ color: "red" }}>disabled !</span>
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography variant="subtitle2">
          For any queries , please contact to{" "}
          <span style={{ color: "#7B029E" }}>+919864574576</span>
        </Typography>
      </Box>
    </>
  );
}

export default LoginDialog;
